import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _Promise from '@babel/runtime-corejs3/core-js/promise';
import React__default, { useRef, useState, useEffect } from 'react';
import { script, hooks } from '@bilibili-maoer/web-utils';
import qs from 'qs';
import useLocation from 'react-use/lib/useLocation';
import sha1 from 'sha1';
import { getWeChatToken, EWxScene } from '../utils/api.js';
import { LAND_PAGE_URL, fmAppId, appId } from '../utils/constant.js';

var getWechatSignature = function getWechatSignature(_ref) {
  var _context, _context2, _context3;

  var ticket = _ref.ticket,
      url = _ref.url,
      timestamp = _ref.timestamp,
      nonce = _ref.nonce;

  var strToSign = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "jsapi_ticket=".concat(ticket, "&noncestr=")).call(_context3, nonce, "&timestamp=")).call(_context2, timestamp, "&url=")).call(_context, url);

  return sha1(strToSign);
}; // 将微信授权函数提升为全局函数方便后续调用


var configWx;

var initWxConfig = function initWxConfig() {
  return (// 微信开放标签开发文档链接: https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html#1
    new _Promise(function (resolve) {
      _Promise.all([script.loadScript('wx-bridge-js', '//res.wx.qq.com/open/js/jweixin-1.6.0.js'), getWeChatToken(EWxScene.ServiceAccount)]).then(function (value) {
        var _value = _slicedToArray(value, 2),
            res = _value[1];

        if (res && res.info) {
          var wechat = res.info.wechat;

          configWx = function configWx() {
            var timestamp = Math.floor(Date.now() / 1000); // eslint-disable-next-line @typescript-eslint/no-magic-numbers

            var nonce = Math.random().toString(16).substring(2);
            var signature = getWechatSignature({
              ticket: wechat.ticket,
              url: window.location.href,
              timestamp: timestamp,
              nonce: nonce
            });
            wx.config({
              debug: false,
              appId: appId,
              timestamp: timestamp,
              nonceStr: nonce,
              signature: signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'shareTimeline', 'sendAppMessage'],
              openTagList: ['wx-open-launch-app']
            });
          };

          configWx();
          wx.ready(function () {
            resolve({
              success: true
            });
          });
          wx.error(function () {
            resolve({
              success: false
            });
          });
        }
      }).catch(function () {
        resolve({
          success: false
        });
      });
    })
  );
};

var WxOpenLaunchApp = function WxOpenLaunchApp(_ref2) {
  var extInfoUrl = _ref2.extInfoUrl,
      fallbackFunc = _ref2.fallbackFunc;
  var wxRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      openTagError = _useState2[0],
      setOpenTagError = _useState2[1];

  var _useState3 = useState(function () {
    return initWxConfig();
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      loadPromise = _useState4[0];

  var currentUrl = useLocation();
  /** 页面 url 发生变化时，需要重新获取微信授权 */

  React__default.useEffect(function () {
    var _configWx;

    (_configWx = configWx) === null || _configWx === void 0 ? void 0 : _configWx();
  }, [currentUrl]);
  var handleGoToLand = hooks.useEventCallback(function () {
    if (fallbackFunc) {
      fallbackFunc();
    } else {
      var _context4;

      window.location.href = _concatInstanceProperty(_context4 = "".concat(LAND_PAGE_URL)).call(_context4, extInfoUrl ? qs.stringify({
        url: extInfoUrl
      }, {
        addQueryPrefix: true
      }) : '');
    }
  });

  var handleLaunchClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$loadPromise, success;

      return _regeneratorRuntime.wrap(function _callee$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return loadPromise;

            case 2:
              _yield$loadPromise = _context5.sent;
              success = _yield$loadPromise.success;

              if (!success || openTagError) {
                handleGoToLand();
              }

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee);
    }));

    return function handleLaunchClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var wxRefCurrent = wxRef.current;

    if (wxRefCurrent) {
      // wxRefCurrent?.addEventListener('launch', (e) => {
      //   // 用户点击跳转按钮并对确认弹窗进行操作后触发，无法区分是否是确认还是取消
      // })
      // wxRefCurrent?.addEventListener('ready', (e) => {
      //   // 标签初始化完毕，可以进行点击操作
      // })
      wxRefCurrent.addEventListener('error', // const errMsg = e.detail.errMsg
      // errMsg = 'launch:fail_check fail': appId 校验失败，或者直接点击访问链接, launch:fail: 未安装等其他报错
      // appId 校验失败，或者直接点击访问链接
      handleGoToLand);
    }

    var handleOpenTagError = function handleOpenTagError() {
      return setOpenTagError(true);
    };

    document.addEventListener('WeixinOpenTagsError', handleOpenTagError);
    return function () {
      document.removeEventListener('WeixinOpenTagsError', handleOpenTagError);

      if (wxRefCurrent) {
        wxRefCurrent.removeEventListener('error', handleGoToLand);
      }
    };
  }, [handleGoToLand]);
  return /*#__PURE__*/React__default.createElement("wx-open-launch-app", {
    appid: fmAppId,
    extinfo: extInfoUrl,
    ref: wxRef,
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    },
    onClick: handleLaunchClick
  }, /*#__PURE__*/React__default.createElement("script", {
    type: "text/wxtag-template"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

export { WxOpenLaunchApp };
